import { authPageTheme } from './theme.js'

export const signupConfirmation = {
  extends: 'Page',
  metadata: (el) => ({ title: el.call('polyglot', 'auth.page.signupConfirmation.title') }),
  flow: 'y',
  align: 'center center',
  padding: 'D C',
  width: '100%',
  height: '100dvh',
  maxWidth: 'none',
  ...authPageTheme,

  // Review r3 D5: nothing is confirmed on load — the person presses
  // Continue (confirmEmail). D4: a confirm that dropped the pre-set password
  // leaves `setPasswordToken` and the ConfirmSetPassword step.
  // Review r4 N2: previewConfirmation fills targetEmail (server-read) and
  // otherAccountEmail (a different signed-in account) before Continue.
  state: {
    awaitingContinue: true,
    previewRequested: false,
    previewReady: false,
    targetEmail: '',
    otherAccountEmail: '',
    loading: false,
    success: false,
    error: null,
    emailTaken: false,
    setPasswordToken: null,
    newPassword: '',
    savingPassword: false,
    setPasswordError: null
  },

  ConfirmCard: {
    flow: 'y',
    gap: 'C',
    padding: 'D',
    width: '100%',
    maxWidth: 'I',
    round: 'radiusSheet',
    background: 'overlay',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'line',

    Head: {
      flow: 'y',
      gap: 'A',
      Eyebrow: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: 'blue',
        text: '{{ auth.confirm.eyebrow | polyglot }}'
      },
      Title: {
        tag: 'h1',
        fontSize: 'D',
        fontWeight: '700',
        color: 'title',
        letterSpacing: '-0.02em',
        text: '{{ auth.confirm.heading | polyglot }}'
      }
    },

    Body: {
      flow: 'y',
      gap: 'B',
      align: 'center center',

      ConfirmContinue: {
        if: (el, s) => !!s.awaitingContinue,
        flow: 'y',
        align: 'center center',
        gap: 'B',
        width: '100%',
        // Read only (review r4 N2): names the account; never confirms.
        onRender: (el) => {
          el.call('previewConfirmation')
        },
        PreviewPending: {
          if: (el, s) => !s.previewReady,
          LoadingSpinner: { boxSize: 'C' }
        },
        P: {
          if: (el, s) => !!s.previewReady,
          text: '{{ auth.confirm.continueBody | polyglot }}',
          textAlign: 'center',
          color: 'paragraph',
          maxWidth: 'G'
        },
        TargetEmail: {
          if: (el, s) => !!s.previewReady && !!s.targetEmail,
          tag: 'strong',
          text: (el, s) => s.targetEmail,
          color: 'title',
          textAlign: 'center',
          wordBreak: 'break-all'
        },
        OtherAccountNotice: {
          if: (el, s) => !!s.previewReady && !!s.otherAccountEmail,
          role: 'alert',
          text: (el, s) =>
            el
              .call('polyglot', s.targetEmail ? 'auth.confirm.otherAccount' : 'auth.confirm.otherAccountUnnamed')
              .replace('{email}', s.otherAccountEmail),
          textAlign: 'center',
          color: 'warningInk',
          maxWidth: 'G'
        },
        ContinueButton: {
          if: (el, s) => !!s.previewReady,
          extends: ['Button', 'ClickableItem'],
          text: (el, s) =>
            el.call('polyglot', s.otherAccountEmail ? 'auth.confirm.switchContinue' : 'auth.confirm.continue'),
          width: '100%',
          onClick: async (_, el) => {
            await el.call('confirmEmail')
          }
        }
      },

      LoadingState: {
        if: (el, s) => s.loading,
        flow: 'y',
        align: 'center center',
        gap: 'B',
        LoadingSpinner: { boxSize: 'D' },
        Text: { text: '{{ auth.confirm.loading | polyglot }}', fontSize: 'B', color: 'caption' }
      },

      EmailConfirmationSuccess: {
        if: (el, s) => !s.loading && s.success && !s.setPasswordToken
      },

      ConfirmSetPassword: {
        if: (el, s) => !s.loading && s.success && !!s.setPasswordToken
      },

      EmailConfirmationError: {
        if: (el, s) => !s.awaitingContinue && !s.loading && !s.success && !s.emailTaken
      },

      EmailConfirmationTaken: {
        if: (el, s) => !s.loading && !!s.emailTaken
      }
    }
  }
}
